import * as actions from './actions'
import * as getters from './getters'
import * as mutations from './mutations'

export const createInitialState = () => ({
  transportOrders: {
    orders: [],
    pagination: {
      totalCount: 0,
      pageNumber: 1,
      nextPageNumber: null,
      previousPageNumber: null
    },
    filters: {},
    progress: {}
  },
  orderDetails: null,
  ableToUploadPodDocuments: false,
  podDocuments: [],
  podError: null,
  podProcessStatus: null,
  missingDocuments: [],
  podInProgressTransition: false,
  dispatchingConfirmation: null
})

export default {
  state: createInitialState(),
  getters,
  mutations,
  actions
}
